import { ContentEditable as LexicalContentEditable } from '@lexical/react/LexicalContentEditable';

export const ContentEditable = () => (
  <LexicalContentEditable className="p-4 overflow-auto rounded-b-[10px] max-h-[200px]" />
);
